import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * This component show a refresh icon that rotates when the refresh state is set
 *
 * How to use it:
 * Just add the component in the place you wan to set, and pass the refresh state.
 * It has a refresh event emitter to the user can start the refresh state
 *
 * @example
 * <div>
 *     <cw-refresh-button [isRefreshing]="isLoading" (refresh)="refreshList()"></cw-refresh-button>
 * </div>
 */
@Component({
    selector: 'cw-refresh-button',
    templateUrl: 'refresh-button.component.html',
    styleUrls: ['refresh-button.component.scss'],
    standalone: false,
})
export class RefreshButtonComponent {
    /** Current refresh state */
    @Input() isRefreshing = true;
    /** Set component as disabled */
    @Input() disabled = false;

    /** Event that emits when the user clicks in the component */
    @Output() refresh = new EventEmitter<void>();

    /* istanbul ignore next */
    /**
     * Emits a refresh event when clicking in the component
     */
    onRefresh(): void {
        if (!this.disabled) {
            this.refresh.emit();
        }
    }
}
